import type { BatchTransition } from '@/pages/Business/pages/BatchCheckpoints/models';
import { externalOperatorService } from './externalOperatorService';

const externalOperatorBatchTransitionsApi = externalOperatorService.injectEndpoints({
  endpoints: (builder) => ({
    getExternalOperatorBatchTransitions: builder.query<BatchTransition[], void>({
      query: () => ({
        url: '/external-operator/transitions/batch',
      }),
      providesTags: ['ExternalOperatorBatchTransition'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetExternalOperatorBatchTransitionsQuery } =
  externalOperatorBatchTransitionsApi;
